import React, { useState } from 'react';
import { portfolioProjects } from '../data/mock';
import { ExternalLink, X } from 'lucide-react';

export const Portfolio = () => {
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <section id="portfolio" className="py-24 bg-light relative">
      {/* Modale de projet */}
      {selectedProject && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 animate-in fade-in duration-300"
             onClick={() => setSelectedProject(null)}>
          <div className="relative max-w-5xl w-full bg-dark rounded-sm shadow-2xl overflow-hidden"
               onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedProject(null)}
              className="absolute top-4 right-4 z-10 bg-dark/80 hover:bg-gold text-white hover:text-dark p-2 rounded-full transition-all duration-300"
            >
              <X className="w-6 h-6" />
            </button>
            
            <div className="grid md:grid-cols-2 gap-0">
              <div className="aspect-square md:aspect-auto">
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <span className="inline-block text-xs uppercase tracking-wider text-gold border border-gold/50 px-3 py-1 rounded-full mb-4 w-fit">
                  {selectedProject.category}
                </span>
                <h3 className="text-3xl md:text-4xl font-playfair font-bold text-white mb-4">
                  {selectedProject.title}
                </h3>
                <p className="text-gray-300 leading-relaxed mb-6">
                  {selectedProject.description}
                </p>
                <div className="border-t border-gold/20 pt-6">
                  <p className="text-sm text-gray-400 mb-4">
                    Un projet JENMA Concept qui allie précision technique et créativité pour créer des espaces uniques et élégants.
                  </p>
                  <div className="flex flex-wrap gap-3">
                    <button
                      onClick={() => {
                        setSelectedProject(null);
                        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="bg-gold hover:bg-gold-light text-dark font-semibold px-6 py-3 rounded-sm transition-all duration-300 shadow-gold"
                    >
                      Démarrer votre projet
                    </button>
                    {selectedProject.configurator && (
                      <a
                        href={`/configurateur?cat=${selectedProject.configurator}`}
                        data-testid="project-configure-link"
                        className="border border-gold text-gold hover:bg-gold hover:text-dark font-semibold px-6 py-3 rounded-sm transition-all duration-300"
                      >
                        Configurer ce type d'espace
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="h-[1px] w-12 bg-gold mx-auto"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-dark mb-6">
            Nos Réalisations
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Découvrez une sélection de projets où chaque détail compte
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {portfolioProjects.map((project) => (
            <div
              key={project.id}
              data-testid={`portfolio-card-${project.id}`}
              className="group relative overflow-hidden rounded-sm shadow-luxury cursor-pointer"
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => setSelectedProject(project)}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={`${project.image}?w=600&h=750&fit=crop&q=90`}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              
              <div className={`absolute inset-0 bg-gradient-to-t from-dark via-dark/80 to-transparent transition-opacity duration-500 ${
                hoveredId === project.id ? 'opacity-100' : 'opacity-70'
              }`}>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="mb-2">
                    <span className="inline-block text-xs uppercase tracking-wider text-gold border border-gold/50 px-3 py-1 rounded-full">
                      {project.category}
                    </span>
                  </div>
                  <h3 className="text-2xl font-playfair font-bold mb-2 group-hover:text-gold transition-colors duration-300">
                    {project.title}
                  </h3>
                  <p className={`text-sm text-gray-300 leading-relaxed transition-all duration-500 ${
                    hoveredId === project.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                  }`}>
                    {project.description}
                  </p>
                  <div className={`flex items-center mt-4 text-gold transition-all duration-500 ${
                    hoveredId === project.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                  }`}>
                    <span className="text-sm mr-2">Voir le projet</span>
                    <ExternalLink className="w-4 h-4" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
